/* eslint-disable @typescript-eslint/no-explicit-any */
function isObject(item) {
  return item !== null && typeof item === 'object';
}
export function merge(target) {
  for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }
  if (!sources.length) return target;
  var source = sources.shift();
  if (isObject(target) && isObject(source)) {
    // eslint-disable-next-line no-restricted-syntax
    for (var _key2 in source) {
      if (isObject(source[_key2])) {
        var _Object$assign;
        if (!target[_key2]) Object.assign(target, (_Object$assign = {}, _Object$assign[_key2] = {}, _Object$assign));
        merge(target[_key2], source[_key2]);
      } else {
        var _Object$assign2;
        Object.assign(target, (_Object$assign2 = {}, _Object$assign2[_key2] = source[_key2], _Object$assign2));
      }
    }
  }
  return merge.apply(void 0, [target].concat(sources));
}
export function keyBy(array, key) {
  return array.reduce(function (result, item) {
    var keyValue;
    if (typeof key === 'function') {
      keyValue = key(item);
    } else if (key in item) {
      keyValue = String(item[key]);
    } else {
      throw new Error("Key \"" + String(key) + "\" does not exist on item");
    }
    result[keyValue] = item;
    return result;
  }, {});
}
export function mapValues(obj, iteratee) {
  var result = {};
  // eslint-disable-next-line no-restricted-syntax
  for (var _key3 in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, _key3)) {
      result[_key3] = iteratee(obj[_key3], _key3);
    }
  }
  return result;
}
export function mapKeys(obj, iteratee) {
  return Object.keys(obj).reduce(function (result, key) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    var newKey = iteratee(obj[key], key); // 使用 iteratee 函数来获取新的键
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    result[newKey] = obj[key]; // 将值赋给新的键
    return result;
  }, {});
}
export function forEach(collection, iteratee) {
  if (Array.isArray(collection)) {
    for (var index = 0; index < collection.length; index++) {
      if (iteratee(collection[index], index.toString()) === false) {
        break;
      }
    }
  } else {
    var keys = Object.keys(collection);
    for (var _i = 0, _keys = keys; _i < _keys.length; _i++) {
      var _key4 = _keys[_i];
      if (iteratee(collection[_key4], _key4) === false) {
        break;
      }
    }
  }
}
export function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (typeof value === 'string' || Array.isArray(value)) {
    return value.length === 0;
  }
  if (typeof value === 'object') {
    return Object.keys(value).length === 0;
  }
  if (value instanceof Map || value instanceof Set) {
    return value.size === 0;
  }
  return false;
}